import { useMutation } from '@tanstack/react-query';
import {
  WithdrawRequestService,
  ApproveBidvAutoBatchWithdrawRequestEntity,
  ApproveBidvAutoWithdrawRequestEntity,
  ApproveBidvAutoWithdrawRequestDto,
} from 'services/openapi';

export type ApproveBidvAutoRequestWithdrawType = {
  id: string;
  variables: ApproveBidvAutoWithdrawRequestDto;
};

export type ApproveBidvAutoBatchRequestWithdrawType = {
  withdrawRequestIds: string[];
  pinCode: string;
  remark?: string;
};

export const useApproveBidvAutoRequestWithdrawMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<
      ApproveBidvAutoWithdrawRequestEntity,
      Error,
      ApproveBidvAutoRequestWithdrawType
    >({
      mutationFn: (request: ApproveBidvAutoRequestWithdrawType) => {
        return WithdrawRequestService.withdrawRequestControllerApproveBidvAuto(
          request.id,
          request.variables,
        );
      },
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};

export const useApproveBidvAutoBatchRequestWithdrawMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<
      ApproveBidvAutoBatchWithdrawRequestEntity,
      Error,
      ApproveBidvAutoBatchRequestWithdrawType
    >({
      mutationFn: (request: ApproveBidvAutoBatchRequestWithdrawType) => {
        return WithdrawRequestService.withdrawRequestControllerApproveBidvAutoBatch(
          request as any,
        );
      },
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
